import {
    faBoxesStacked,
    faBoxOpenFull,
    faBuilding,
    faBuildingFlag,
    faClipboard,
    faClock,
    faDoorOpen,
    faFolders,
    faHandHeart,
    faHandHoldingBox,
    faQuestionSquare,
    faSteeringWheel,
    faTruck,
    faTruckBolt,
    faUser,
    faUserCrown,
    faUserMagnifyingGlass,
    faUserTie,
    faWatch,
    IconDefinition
} from "@fortawesome/pro-regular-svg-icons";
import {FontAwesomeIconProps as UpstreamFontAwesomeIconProps} from "@fortawesome/react-fontawesome";
import {z} from "zod/v4";
import {TieredOrActive} from "./dispatch/tieredOrActive.tsx";

export const FontAwesomeIconProps = z.custom<UpstreamFontAwesomeIconProps>();

// export interface FontAwesomeJoyIconProps extends SvgIconProps {
//     icon: IconDefinition | null;
// }
//
// const FontAwesomeJoyIconRoot
//     = styled("svg", {
//     name: "FontAwesomeJoyIcon",
//     slot: "root",
// })<{ ownerState: FontAwesomeJoyIconProps }>(() => {
//     return {};
// });
//
// export const FontAwesomeJoyIcon
//     = React.forwardRef<SVGSVGElement, FontAwesomeJoyIconProps>(
//     function FontAwesomeJoyIcon(props, ref) {
//         const {icon} = props;
//
//         if (!icon) {
//             return null;
//         }
//
//         const {
//             icon: [width, height, , , svgPathData],
//         } = icon;
//
//         return <SvgIcon viewBox={`0 0 ${width} ${height}`} ownerState={props} ref={ref}
//                         component={FontAwesomeJoyIconRoot} {...props}>
//             {typeof svgPathData === "string" ? (
//                 <path d={svgPathData}/>
//             ) : (
//                 /**
//                  * A multi-path Font Awesome icon seems to imply a duotune icon. The 0th path seems to
//                  * be the faded element (referred to as the "secondary" path in the Font Awesome docs)
//                  * of a duotone icon. 40% is the default opacity.
//                  *
//                  * @see https://fontawesome.com/how-to-use/on-the-web/styling/duotone-icons#changing-opacity
//                  */
//                 svgPathData.map((d: string, i: number) => (
//                     <path key={`fa ${i}`} style={{opacity: i === 0 ? 0.4 : 1}} d={d}/>
//                 ))
//             )}
//         </SvgIcon>
//
//     });

export interface EntityIconMap {
    company: UpstreamFontAwesomeIconProps;
    sendCompany: UpstreamFontAwesomeIconProps;
    transportCompany: UpstreamFontAwesomeIconProps;
    receiveCompany: UpstreamFontAwesomeIconProps;
    venue: UpstreamFontAwesomeIconProps;
    agent: UpstreamFontAwesomeIconProps;
    admin: UpstreamFontAwesomeIconProps;
    driver: UpstreamFontAwesomeIconProps;
    admitter: UpstreamFontAwesomeIconProps;
    inspector: UpstreamFontAwesomeIconProps;
    supervisor: UpstreamFontAwesomeIconProps;
    truck: UpstreamFontAwesomeIconProps;
    truckModel: UpstreamFontAwesomeIconProps;
    job: UpstreamFontAwesomeIconProps;
    bundle: UpstreamFontAwesomeIconProps;
    scheduledBundleTransfer: UpstreamFontAwesomeIconProps;
    wasteFlavor: UpstreamFontAwesomeIconProps;
    waste: UpstreamFontAwesomeIconProps;
}

function makeEntityIconMap(): Map<keyof EntityIconMap, UpstreamFontAwesomeIconProps> {
    const rv = new Map<keyof EntityIconMap, UpstreamFontAwesomeIconProps>;
    rv.set("company", {icon: faBuildingFlag});
    rv.set("sendCompany", {icon: faHandHoldingBox});
    rv.set("transportCompany", {icon: faTruckBolt});
    rv.set("receiveCompany", {icon: faHandHeart});
    rv.set("venue", {icon: faBuilding});
    rv.set("agent", {icon: faUser});
    rv.set("admin", {icon: faUserCrown});
    rv.set("driver", {icon: faSteeringWheel});
    rv.set("admitter", {icon: faDoorOpen});
    rv.set("inspector", {icon: faUserMagnifyingGlass});
    rv.set("supervisor", {icon: faUserTie});
    rv.set("truck", {icon: faTruck});
    rv.set("job", {icon: faClipboard});
    rv.set("bundle", {icon: faBoxesStacked});
    rv.set("scheduledBundleTransfer", {icon: faClock});
    rv.set("truckModel", {icon: faQuestionSquare});
    rv.set("wasteFlavor", {icon: faQuestionSquare});
    rv.set("waste", {icon: faBoxOpenFull});
    return rv;
}

const entityIconMap = makeEntityIconMap();

export function iconForEntityType(et: keyof EntityIconMap): UpstreamFontAwesomeIconProps {
    const rv = entityIconMap.get(et);
    if (!rv) {
        throw new Error(`no icon for ${et}`);
    }
    return rv;
}

// export const IconableEntityViewRoot
//     = styled("div", {
//     name: "IconableEntityView",
//     slot: "root"
// })<{ ownerState: IconableEntityViewProps }>(() => {
//     return {};
// })
//
//
// export const IconableEntityView
//     = React.forwardRef<HTMLDivElement, IconableEntityViewProps>(
//     function IconableEntityView(props, ref) {
//         const entity = props.entity;
//         let code = entity.code;
//         const displayName = entity.displayName;
//         if (code === displayName) {
//             code = undefined;
//         }
//
//         const mustSx = {alignItems: "center", display: "flex"}
//         const sx = props.sx ? {...props.sx, ...mustSx} : mustSx;
//
//         const icons = iconsForEntity(entity);
//         return <Stack direction="row" sx={sx} ref={ref}>
//             {icons.map(icon => <FontAwesomeIcon key={icon.iconName} icon={icon}/>)}
//             <div>
//                 {code && code}
//                 {code && displayName && "・"}
//                 {displayName && displayName}
//             </div>
//         </Stack>
//     });

export const tieredActiveIcons: Record<TieredOrActive, IconDefinition> = {
    tiered: faFolders,
    active: faWatch,
};

